import React, {useEffect} from 'react';
import {Link, useNavigate} from "react-router-dom";
import {URLS} from "@/lib/urls";
import {Button} from "antd";

function HomePage(props) {

    const navigate = useNavigate();
    useEffect(() => {
        navigate(URLS.gateway.selector);
    }, []);

    return (
        <div>
            Home Page
            <br/>
            Hi.
            <Button>
                <Link to={URLS.student.dashboard}>Student dashboard</Link>
            </Button>
            <br/>
            <Button>
                <Link to={URLS.auth.login}>Login</Link>
            </Button>
        </div>
    );
}

export default HomePage;